import { render, staticRenderFns } from "./ABuscarPersona.vue?vue&type=template&id=617ab80c"
import script from "./ABuscarPersona.vue?vue&type=script&lang=js"
export * from "./ABuscarPersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports